import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

export interface ColumnConfig {
	name: string;
	prop: string;
	visible: boolean;
}

@Component({
	selector: 'app-new-column-selector',
	templateUrl: './new-column-selector.component.html',
	styleUrls: ['./new-column-selector.component.scss'],
})
export class NewColumnSelectorComponent implements OnChanges {
	@Input() columns: ColumnConfig[] = [];
	@Output() columnToggled = new EventEmitter<ColumnConfig>();
	@Output() columnsChange = new EventEmitter<ColumnConfig[]>();

	isOpen = false;
	search = '';

	private defaults: Record<string, boolean> = {};
	private defaultsCaptured = false;

	constructor(private elRef: ElementRef) {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['columns'] && !this.defaultsCaptured && this.columns?.length) {
			this.defaults = {};
			for (const col of this.columns) {
				this.defaults[col.prop] = col.visible;
			}
			this.defaultsCaptured = true;
		}
	}

	get filteredColumns(): ColumnConfig[] {
		const term = this.search.trim().toLowerCase();
		if (!term) return this.columns;
		return this.columns.filter((c) => c.name.toLowerCase().includes(term));
	}

	toggleOpen(): void {
		this.isOpen = !this.isOpen;
		if (!this.isOpen) this.search = '';
	}

	toggleColumn(column: ColumnConfig): void {
		column.visible = !column.visible;
		this.columnToggled.emit(column);
		this.columnsChange.emit(this.columns);
	}

	selectAll(): void {
		this.columns.forEach((c) => (c.visible = true));
		this.columnsChange.emit(this.columns);
	}

	resetToDefault(): void {
		if (!this.defaultsCaptured) return;
		this.columns.forEach((c) => {
			if (this.defaults[c.prop] !== undefined) c.visible = this.defaults[c.prop];
		});
		this.columnsChange.emit(this.columns);
	}

	@HostListener('document:click', ['$event'])
	onDocumentClick(event: MouseEvent): void {
		if (this.isOpen && !this.elRef.nativeElement.contains(event.target)) {
			this.isOpen = false;
			this.search = '';
		}
	}

	@HostListener('document:keydown.escape')
	onEscape(): void {
		if (this.isOpen) {
			this.isOpen = false;
			this.search = '';
		}
	}

	trackByProp(index: number, column: ColumnConfig): string {
		return column.prop;
	}
}
